import axios from 'axios';

axios.interceptors.request.use(config => {
  if (typeof window === 'undefined') {
    return config;
  }

  const token = window.localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `bearer ${token}`;
  }

  return config;
});

const listService = {

  listAllSubPrefeitura() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/subprefeituras?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listTipoSexo() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/tipo_sexo?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listDistritos(id) {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/distritos?idSubprefeitura=' + id + '&random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listEstadoCivil() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/estado_civil?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listNacionalidade() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/nacionalidade?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listPais() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/pais?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listCidadePorUF(uf) {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/cidades/' + uf + '?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listRaca() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/raca?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listIdentidadeSexual() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/identidade_sexual?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listFormasCuidado() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/formas_cuidado?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listTipologiaServicoReordenamento(id) {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/tipologia_servico_reordenamento/' + id + '?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },
  listTipologiaServicoAcolhimento(id) {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/tipologia_servico_acolhimento/' + id + '?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },
  listTipologiaServicoAcolhimentoSigiloso() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/tipologia_servico_sigiloso?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listServico() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/servico?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listMotivoProcura() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/motivo_procura?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listMotivoReordenamento() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/motivo_reordenamento?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listOrgaoSolicitante(id) {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/orgao_solicitante/' + id + '?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },
  listOrigemProcura() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/origem_procura?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listTipoLogradouro() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/tipo_logradouro?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },

  listDeficiencia() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/deficiencia?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },
  listSituacoesSolicitacao() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/situacao_solicitacao?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },
  getStreetByCEP(data) {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/logradouro_cep/' + data + '?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },
  getListPregnantEnable() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/permite_gestante?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },
  listGrauDependencia() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/grau_dependencia?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },
  listVIJ() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/vara_infancia?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  },
  listMotivosCancelamento() {
    return new Promise((resolve, reject) => {
      axios.get('/api/listas/motivo_cancelamento?random=' + Math.random())
        .then(response => {
          resolve(response);
        })
        .catch(response => {
          reject(response);
        });
    });
  }

};

export default listService;
